import React, {useContext} from 'react';
import UserContext from '../components/common/UserContext.js';

// css
import '../assets/css/Help.css';

// reactstrap
import {Col, Row} from 'reactstrap';

// components
import PageHeader from '../components/common/PageHeader.js';
import HelpMenu from '../components/Help/HelpMenu.js';
import {toHtml} from '../components/common/utilities.js';

// images
import KSMUsersAddModal from '../assets/img/Help/ksm-users-add-modal.png';
import KSMUsersEditUserModal from '../assets/img/Help/ksm-users-edit-user-modal.png'
import KSMUsersEditUserOption from '../assets/img/Help/ksm-users-edit-user-option.png';
import KSMUsersPage from '../assets/img/Help/ksm-users-page.png'
import KSMUsersRemoveUserOption from '../assets/img/Help/ksm-users-remove-user-option.png'

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {Text} from '../components/common/MultilingualText.js';
import {
    addUserKey,
    managingUsersKey,
    editingUserInfoKey,
    removingUserKey,
    helpUsersManagingSectionKey,
    helpUsersAddUserSectionKey,
    helpUsersEditUserSectionKey,
    helpUsersRemoveUserSectionKey,
    mainMessages,
} from '../assets/text/MultilingualText.js';


function UsersHelp(props) {
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    const helpContent = {
        'header': {
            key: managingUsersKey,
            default: mainMessages[siteLanguageDefault][managingUsersKey]
        },
        'topics': [
            {
                key: managingUsersKey,
                default: mainMessages[siteLanguageDefault][managingUsersKey],
                hash: "#managing-users"
            },
            {
                key: addUserKey,
                default: mainMessages[siteLanguageDefault][addUserKey],
                hash: "#add-user"
            },
            {
                key: editingUserInfoKey,
                default: mainMessages[siteLanguageDefault][editingUserInfoKey],
                hash: "#edit-user"
            },
            {
                key: removingUserKey,
                default: mainMessages[siteLanguageDefault][removingUserKey],
                hash: "#remove-user"
            }
        ],
        'faq': []
    }

    const helpUsersContent = localization.toLanguageString(
        helpUsersManagingSectionKey,
        mainMessages[siteLanguageDefault][helpUsersManagingSectionKey]
    );

    const helpUsersAddUserSectionContent = localization.toLanguageString(
        helpUsersAddUserSectionKey,
        mainMessages[siteLanguageDefault][helpUsersAddUserSectionKey]
    );

    const helpUsersEditUserSectionContent = localization.toLanguageString(
        helpUsersEditUserSectionKey,
        mainMessages[siteLanguageDefault][helpUsersEditUserSectionKey]
    );

    const helpUsersRemoveUserSectionContent = localization.toLanguageString(
        helpUsersRemoveUserSectionKey,
        mainMessages[siteLanguageDefault][helpUsersRemoveUserSectionKey]
    );

    return (
        <>
            <PageHeader/>
            <div className={"ksm-page-container"}>
                <Row>
                    <Col xs="3">
                        <HelpMenu
                            siteLanguageDefault={siteLanguageDefault}
                            helpContent={helpContent}
                        />
                    </Col>
                    <Col xs="9">
                        <div
                            className={"k-h3 header"}
                            id="managing-users"
                        >
                            <Text
                                textkey={managingUsersKey}
                                textdefault={mainMessages[siteLanguageDefault][managingUsersKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <p>
                                {toHtml(helpUsersContent.section_one)}
                            </p>
                            <p>
                                {toHtml(helpUsersContent.section_two)}
                            </p>
                            <p>
                                {helpUsersContent.section_three}
                            </p>
                            <img src={KSMUsersPage} height={210} width={900}
                                 alt={'ksm-users-page'}/>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="add-user"
                        >
                            <Text
                                textkey={addUserKey}
                                textdefault={mainMessages[siteLanguageDefault][addUserKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <p>
                                {helpUsersAddUserSectionContent.section_one}
                            </p>
                            <ol type='a'>
                                {
                                    helpUsersAddUserSectionContent.section_one_bullets?.map((bullet, bulletIndex) => {
                                        return <li key={`add-user-${bulletIndex}`}>
                                            {toHtml(bullet)}
                                        </li>;
                                    })
                                }
                            </ol>
                            <img src={KSMUsersAddModal} height={380} width={800}
                                 alt={'ksm-users-add-modal'}/>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="edit-user"
                        >
                            <Text
                                textkey={editingUserInfoKey}
                                textdefault={mainMessages[siteLanguageDefault][editingUserInfoKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section" style={{display: 'flex', flexDirection: 'column'}}>
                            <p>
                                {helpUsersEditUserSectionContent.section_one}
                            </p>
                            <img src={KSMUsersEditUserOption} height={575} width={425}
                                 alt={'ksm-users-edit-user-option'}/>
                            <img src={KSMUsersEditUserModal} height={335} width={800}
                            alt={'ksm-users-edit-user-modal'}/>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="remove-user"
                        >
                            <Text
                                textkey={removingUserKey}
                                textdefault={mainMessages[siteLanguageDefault][removingUserKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            <p>
                                {helpUsersRemoveUserSectionContent.section_one}
                            </p>
                            <p>
                                {helpUsersRemoveUserSectionContent.section_two}
                            </p>
                            <img src={KSMUsersRemoveUserOption} height={464} width={390}
                                 alt={'ksm-users-remove-user-option'}/>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default UsersHelp;

